import { useDeviceSize } from "hooks";
import { ANIMATED_CARD_GTM, ANIMATED_CARD_MP } from "modules/home-page/trackingConsts";
import { trackEvents } from "utils/trackingUtils";
import type { ReactNode } from "react";
import { ChakraLink as Link } from "@airhelp/react-ui-components";
import type { CardsContainerProps } from "./CardsContainer.d";
import { CardsDesktop, CardsMobile } from "./Cards";

const AsLink = ({ children, cardsUrl }: { children: ReactNode; cardsUrl: string }) => {
  const handleTrackEvents = () => trackEvents({ gtmEvent: ANIMATED_CARD_GTM, mixpanelEvent: ANIMATED_CARD_MP });

  return (
    <Link
      href={cardsUrl}
      display="block"
      rounded="lg"
      _hover={{ textDecoration: "none", borderColor: "danger.500" }}
      onClick={handleTrackEvents}
      data-testid="we-solve-card"
      sx={{ svg: { h: 10, w: 10 } }}
    >
      {children}
    </Link>
  );
};

const CardsContainer = ({ cards, cardsHeightDesktop, cardsUrl }: CardsContainerProps) => {
  const { isTabletOrDesktop } = useDeviceSize();

  return isTabletOrDesktop ? (
    cardsUrl ? (
      <AsLink cardsUrl={cardsUrl}>
        <CardsDesktop cards={cards} cardsHeightDesktop={cardsHeightDesktop} />
      </AsLink>
    ) : (
      <CardsDesktop cards={cards} cardsHeightDesktop={cardsHeightDesktop} />
    )
  ) : cardsUrl ? (
    <AsLink cardsUrl={cardsUrl}>
      <CardsMobile cards={cards} />
    </AsLink>
  ) : (
    <CardsMobile cards={cards} />
  );
};

export default CardsContainer;
